import { ServiceDefinition } from '@pershing/pershing-core';

export class TradingServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;

    // TODO - check this name and make sure it is correct
    uri: string = 'trading/common';
    version: string = 'v1';
    family: string = 'pershing';
    appName: string = 'common-trading'; 
    serviceName: string = 'app';
    mnemonic: string = 'nxp';

    static getInstance(platform: string): ServiceDefinition {
        if (!TradingServiceDefinition.instance) {
            TradingServiceDefinition.instance = new TradingServiceDefinition();
            if (platform === 'retail') {
                TradingServiceDefinition.instance.family = 'netxinvestor';
                TradingServiceDefinition.instance.mnemonic = 'nxc';
            }
        }
        return TradingServiceDefinition.instance;
    }

    
    private constructor() {
        //intentional empty constructor
    }
}
